/**
 * #863: Çıkışta Grafana (gf_sso) ve blog (blog_gate) kapı çerezlerini sunucuya sildir.
 *
 * Çerezler HttpOnly olduğundan JS ile silinemez; backend aynı Path ile süresi dolmuş
 * Set-Cookie basar. Uç kimlik İSTEMEZ (çıkışta JWT bayat olabilir), bu yüzden düz fetch.
 *
 * BEST-EFFORT: hiçbir koşulda throw etmez, kullanıcıya hata göstermez, çıkışı en çok
 * `SSO_LOGOUT_TIMEOUT_MS` geciktirir. Ağ hatası / 401 / 500 / zaman aşımı sessizce yutulur.
 */
export const SSO_LOGOUT_URL = '/api/data/admin/sso-logout'
export const SSO_LOGOUT_TIMEOUT_MS = 1500

export async function clearSsoCookies(): Promise<void> {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), SSO_LOGOUT_TIMEOUT_MS)
  try {
    await fetch(SSO_LOGOUT_URL, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      signal: controller.signal,
    })
  } catch {
    // Çıkış akışı bu uca bağlı değil.
  } finally {
    clearTimeout(timer)
  }
}
